"use client"

import React, {FC, useEffect, useState} from 'react'
import {FlexBox} from "@/src/components/FlexBox";
import {Button, Container, Typography} from "@mui/material";
import {ACCEPT_COOKIES_KEY} from "./constants";


const CookiesPanel: FC = () => {

    const [show, setShow] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(ACCEPT_COOKIES_KEY);
        if (!consent) {
            setShow(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem(ACCEPT_COOKIES_KEY, "true");
        setShow(false);
    };

    if (!show) return null;

    return (<FlexBox className={"fixed bottom-0 shadow-[0px_12px_19px_rgba(0,0,0,0.2),_0px_4px_11px_rgba(0,0,0,0.2)] left-0 justify-center w-full bg-white py-[16px] md:pd-[32px] z-header"}>
        <Container>
            <FlexBox className={"flex-col md:flex-row"}>
                <Typography className={"text-dark-grey pb-[16px] md:pr-[64px] md:pb-0"}>
                    {"Ми використовуємо файли cookies, щоб зробити цей сайт зручним саме для Вас. Продовжуючи використовувати наш сайт, Ви погоджуєтесь на використання файлів cookies. В іншому випадку Ви можете самостійно змінити налаштування cookies у Вашому браузері."}
                </Typography>
                <div>
                    <Button variant={"contained"} className={"w-full md:max-w-40"} onClick={acceptCookies}>{"Зрозуміло"}</Button>
                </div>
            </FlexBox>
        </Container>
    </FlexBox>)
}

export { CookiesPanel };
